import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-ok',
  templateUrl: './icon-ok.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconOkComponent {}
